/* Yard Mint Design Studio checkout guard · assets/ym-studio-guard.js
 * A made-to-order line (product type "Custom Coin/Card/Bar/…") must carry a design.
 * If one was added without the studio (e.g. quick add), checkout pauses and the line
 * links back to the studio. Legacy studio lines also carry "Design reference", so they pass.
 */
(() => {
  'use strict';
  if (window.ymStudioGuard) return;
  window.ymStudioGuard = true;
  const root = window.Shopify?.routes?.root || '/';
  const needsDesign = (i) => /^custom\b/i.test(i.product_type || '') && !(i.properties && i.properties['Design reference']);
  const checkoutSel = '[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';

  async function blankLines() {
    try {
      const r = await fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      const cart = await r.json();
      return cart.items.filter(needsDesign);
    } catch {
      return [];
    }
  }

  function notice(host, items) {
    host.querySelector('[data-ym-guard]')?.remove();
    if (!items.length) return;
    const p = document.createElement('p');
    p.dataset.ymGuard = '';
    p.setAttribute('role', 'alert');
    p.style.cssText = 'margin:12px 0;padding:12px 14px;border-left:3px solid #7a5a26;background:#f6efe0;border-radius:0 6px 6px 0;font-size:14px;line-height:1.5';
    p.append('Your ' + items.map((i) => i.product_title).join(', ') + ' needs a design before checkout. ');
    const a = document.createElement('a');
    a.href = items[0].url.split('?')[0] + '?view=design-studio';
    a.textContent = 'Open the Design Studio';
    a.style.textDecoration = 'underline';
    p.append(a, ' — then remove the blank line from your basket.');
    host.prepend(p);
  }

  document.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest(checkoutSel);
      if (!btn || btn.dataset.ymGuardOk) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const items = await blankLines();
      if (!items.length) {
        btn.dataset.ymGuardOk = '1';
        if (btn.form && btn.name === 'checkout') {
          const h = document.createElement('input');
          h.type = 'hidden';
          h.name = 'checkout';
          h.value = '1';
          btn.form.append(h);
          btn.form.submit();
        } else location.assign(btn.href || root + 'checkout');
        return;
      }
      notice(btn.closest('form, .cart-drawer, .cart__summary, .cart-summary, footer, div') || document.body, items);
    },
    true
  );
})();